import styled, { css } from 'styled-components';
import { mediaMixin } from '@zillow/constellation';

import {
    Col,
} from '@zillow/zrs-comet';

// vars
const colMarginBottom = '18px';

export const StyledCol = styled(Col)`
    margin: 0 0 ${colMarginBottom} 0;
    padding: 0 8px;
    background-color: none;

    .ConnectedListing-Ref-Container {
        width: 100%;

        &:last-child {
            margin: 0;
        }

        /* 769 */
        ${mediaMixin('lg', css`
            margin: 0;
        `)}
    }

    /* TODO: remove demo styles */
    display: flex;
    flex-direction: row;
    align-items: flex-start;
`;

export const StyledDiv = styled.div`
    /* TODO: remove demo styles */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 200px;
    border: 1px solid orange;
`;
